import Image, { StaticImageData } from "next/legacy/image";
import React, { useRef } from "react";

import * as S from "./LandingPageSellingPointOrganism.style";

export let sellingPointRef;

const LandingPageSellingPointOrganism = ({
  title,
  sellingPointData,
  course,
}: {
  title: JSX.Element;
  sellingPointData: { img: StaticImageData; title: string; desc: string }[];
  course?: string;
}) => {
  sellingPointRef = useRef();
  return (
    <S.Wrapper ref={sellingPointRef}>
      <S.Title course={course}>{title}</S.Title>
      <S.PointWrapper>
        {sellingPointData.map((card, idx) => (
          <S.Point key={idx}>
            <S.PointImg>
              <Image
                src={card.img}
                alt="card_img"
                quality={100}
                loading="lazy"
              />
            </S.PointImg>
            <S.PointTitle course={course}>{card.title}</S.PointTitle>
            <S.PointDesc course={course}>{card.desc}</S.PointDesc>
          </S.Point>
        ))}
      </S.PointWrapper>
    </S.Wrapper>
  );
};

export default LandingPageSellingPointOrganism;
